import { useState } from "react";
import { CreateCoupon } from "./CouponFunction";
import DropdownSearch from "../Components/DynamicComp/DropdownSearch";

const CreateCouponForm = ({ onClose, onCreated, category }) => {
  const [isAmountDisabled, setIsAmountDisabled] = useState(true);
  const [amountError, setAmountError] = useState('');
  const [formData, setFormData] = useState({
    coupon_code: '',
    promotion_type: '',
    category: '',
    amount: '',
    promotion_start_date: '',
    promotion_end_date: '',
    status: 'active',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
   if (name === "promotion_type") {
    setIsAmountDisabled(!value); 
    setFormData(prev => ({ ...prev, [name]: value, amount: '' })); 
    setAmountError(''); 
    return;
  }

   if (name === "amount" && formData.promotion_type === "Percentage") {
    if (parseFloat(value) >= 100) {
      setAmountError("Percentage amount must be less than 100");
    } else {
      setAmountError('');
    }
  }
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
   const { coupon_code, promotion_type, category, amount, promotion_start_date, promotion_end_date } = formData;
    if (!coupon_code || !promotion_type || !category || !amount || !promotion_start_date || !promotion_end_date) {
      alert("All fields are required. Please fill out the entire form.");
      return; 
    }
    if (formData.promotion_type === "Percentage" && parseFloat(formData.amount) >= 100) {
     alert("Percentage must be less than 100");
     return;
    }
    const payload = formData;
    console.log("payload data",payload)
    try {
      await CreateCoupon(payload);
      onCreated();
      onClose();
    } catch (err) {
      console.error("Create failed", err);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded-md shadow-lg w-full max-w-md"
      >
        <h2 className="text-xl font-semibold mb-4">Create New Coupon</h2>

        <input type="text" name="coupon_code" placeholder="Coupon Code" value={formData.coupon_code} onChange={handleChange} className="w-full mb-2 p-2 border rounded" />
         <select name="promotion_type" value={formData.promotion_type} onChange={handleChange} className="w-full mb-4 p-2 border rounded">
          <option value="" disabled>Select Promotion Type</option>
          <option value="Fixed">Fixed</option>
          <option value="Percentage">Percentage</option>
        </select>
         <DropdownSearch
           options={category.map(cat => cat.product_type_name)}
           placeholder="Select Category"
           onSelect={(selectedValue) =>
           setFormData(prev => ({ ...prev, category: selectedValue }))
          }
         />
        
        <input type="number" name="amount" placeholder="Amount or %" value={formData.amount} onChange={handleChange} disabled={isAmountDisabled} className="w-full mb-2 p-2 border rounded" />
        {amountError && <div className="text-red-600 text-sm mb-2">{amountError}</div>}

        <label className="w-full mb-2 p-2 border rounded">Promotion_start_date</label>
        <input type="date" name="promotion_start_date" placeholder="promotion_start_date" value={formData.promotion_start_date} onChange={handleChange} className="w-full mb-2 p-2 border rounded" />
        <label className="w-full mb-2 p-2 border rounded">Promotion_end_date</label>
        <input type="date" name="promotion_end_date" placeholder=" promotion_end_date"value={formData.promotion_end_date} onChange={handleChange} className="w-full mb-2 p-2 border rounded" />
        
         <select name="status" value={formData.status} onChange={handleChange} className="w-full mb-4 p-2 border rounded">
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
          <option value="expired">Expired</option>
        </select>

        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-400 rounded text-white">Cancel</button>
          <button type="submit" className="px-4 py-2 bg-red-600 rounded text-white">Create</button>
        </div>
      </form>
    </div>
  );
};

export default CreateCouponForm;